"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var _i18nextBrowserLanguagedetector = _interopRequireDefault(require("i18next-browser-languagedetector"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable import/no-webpack-loader-syntax */


var resources;

try {
  resources = require("i18next-resource-store-loader!./locales/index.js");
} catch (e) {
  // Jest doesn't play well with i18next-resource-store-loader! so on error return empty resources
  resources = {};
}

var i18nPassword = _i18next.default.createInstance();

i18nPassword.use(_i18nextBrowserLanguagedetector.default).init({
  resources: resources,
  defaultNS: "translation",
  fallbackLng: "en",
  lng: navigator.language,
  interpolation: {
    escapeValue: false // react already safes from xss

  }
});
var _default = i18nPassword;
exports.default = _default;